import { render, staticRenderFns } from "./SwitcherWithFilter.vue?vue&type=template&id=5ab311ae&scoped=true"
import script from "./SwitcherWithFilter.vue?vue&type=script&lang=ts"
export * from "./SwitcherWithFilter.vue?vue&type=script&lang=ts"
import style0 from "./SwitcherWithFilter.vue?vue&type=style&index=0&id=5ab311ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab311ae",
  null
  
)

export default component.exports